import { faTrash } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useApiCall } from "../api/api";
import type { ExamParticipant } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const PermanentDeleteParticipantModal: FC<{ participant: ExamParticipant }> = (props) => {
  const { destroyParticipant } = useApiCall();
  const reload = useRefresh();

  const confirm = async () => {
    await destroyParticipant(props.participant.examId, props.participant.id);
    reload();
  };

  return (
    <>
      <div>Je staat op het punt om de volgende participant permanent te verwijderen.</div>
      <div className={"font-semibold my-2"}>&middot; {props.participant.name}</div>
      <div>Bij het uitvoeren van deze actie worden ook alle resultaten en certificaten van deze participant verwijderd.</div>

      <div className={"mt-4 text-red-500"}>Let op! Deze actie valt niet terug te draaien.</div>
      <ModalFooter text={"Verwijder"} icon={faTrash} onSubmit={confirm} />
    </>
  );
};
